import { isDate, isObject } from 'lodash-es'

const getTrackablePageName = (path) => {
  const nameMap = {
    'AccountSettings-Login': /^\/account\/settings\/login$/i,
    'AccountSettings-MyLink': /^\/account\/settings\/link$/i,
    'AccountSettings-Profile': /^\/account\/settings\/profile$/i,
    Billing: /^\/billing$/i,
    Calendars: /^\/app\/calendar_connections$/i,
    ConnectiCloud: /^\/app\/calendar_connections\/icloud\/new$/i,
    Dashboard: /^\/dashboard$/i,
    EventTypeEdit: /^\/event_types\/\d+\/edit$/i,
    'EventTypeList-AllTeams': /^\/event_types\/team$/i,
    'EventTypeList-MyCalendly': /^\/event_types\/user\/me$/i,
    'EventTypeList-TeamLanding': /^\/event_types\/team\//i,
    Integrations: /^\/integrations$/i,
    'Integrations-Chrome': /^\/integrations\/chrome$/i,
    'Integrations-GoogleAnalytics': /^\/integrations\/google_analytics$/i,
    'Integrations-GoToMeeting': /^\/integrations\/gotomeeting$/i,
    'Integrations-Intercom': /^\/integrations\/intercom$/i,
    'Integrations-Paypal': /^\/integrations\/paypal$/i,
    'Integrations-Salesforce': /^\/integrations\/salesforce$/i,
    'Integrations-Stripe': /^\/integrations\/stripe$/i,
    'Integrations-Zapier': /^\/integrations\/zapier$/i,
    'Integrations-Zoom': /^\/integrations\/zoom$/i,
    OrganizationUsers: /^\/app\/organization\/users$/i
  }
  const match = Object.entries(nameMap).find(([, pattern]) => pattern.test(path))

  return match ? match[0] : false
}

const forwardToGcpFunction = (forward) => ({ 'Google Cloud Function': forward })

export default {
  identify(userId, traits, options = {}) {
    window.analytics.identify(userId, traits, options)
  },
  trackLink($element, event, properties = {}) {
    window.analytics.trackLink($element, event, properties)
  },
  trackForm($element, event, properties = {}) {
    window.analytics.trackForm($element, event, properties)
  },
  track(event, properties = {}, trackOptions = {}) {
    const { version } = trackOptions ?? {}

    window.analytics.track(event, properties, {
      integrations: forwardToGcpFunction(true),
      ...(typeof version === 'number' && {
        context: { protocols: { event_version: version } }
      })
    })
  },
  trackNamedPage(path) {
    const namedPageName = getTrackablePageName(path)
    if (namedPageName) {
      window.analytics.page(namedPageName)
    }
    window.analytics.page()
  },
  trackClick(element, event, properties = {}) {
    window.analytics.trackClick(element, event, properties)
  },
  // Indicates if value is acceptable by Braze
  // (Braze ignores track events that have attributes that are complex types)
  isTrackableAttributeValue(value) {
    return !isObject(value) || isDate(value)
  }
}
